import React from 'react';
import { ISignUpManager } from 'views/public/SignUp/useSignUpManager';
import ManualSignupForm from './ManualSignupForm';
import SignupForm from './SignupForm';

export interface ISignupOverlayProps {
    displayManualSignUp: boolean;
    setDisplayManualSignUp: (display: boolean) => void;
    signUpManager: ISignUpManager;
}

const SignupOverlay = ({ displayManualSignUp, setDisplayManualSignUp, signUpManager }: ISignupOverlayProps) => (
    <div className="ProForma__overlay">
        <div className="d-flex justify-content-center h-100 mt-sm-3 mt-md-5">
            {displayManualSignUp ? (
                <ManualSignupForm
                    signUpManager={signUpManager}
                    onClickBack={() => setDisplayManualSignUp(false)}
                />
            ) : (
                <SignupForm
                    signUpManager={signUpManager}
                    showManualSignUpForm={() => setDisplayManualSignUp(true)}
                />
            )}
        </div>
    </div>
);

export default SignupOverlay;
